import { FormatIcu } from '@tolgee/format-icu';
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';

import { withBasePath } from '~/shared/utils/base-path.util';

type TolgeeInstance = {
  use: (...args: unknown[]) => TolgeeInstance;
  init: (...args: unknown[]) => TolgeeInstance;
};

function createTolgeeInstance(): TolgeeInstance {
  try {
    const instance = (Tolgee as unknown as () => TolgeeInstance)();

    return instance
      .use(
        BackendFetch({
          prefix: withBasePath('/i18n')
        })
      )
      .use(DevTools())
      .use(FormatIcu())
      .init({
        defaultLanguage: 'pt-BR',
        defaultNs: 'default'
      });
  } catch {
    const dummy: TolgeeInstance = {
      use: () => dummy,
      init: () => dummy
    };

    return dummy;
  }
}

export const tolgee = createTolgeeInstance();
